import React, { useState, useEffect } from "react";
import { Button, Modal, Message, Grid, Table, Label } from "semantic-ui-react";
import { getPatientHomeAddress } from "utils/address";
import { convertMyLabToPatient } from "utils/patientConverter";
import { useIsMobileView } from "hooks/utils";
import moment from "moment-with-locales-es6";
import { Form, Formik, Field } from "formik";
import { Checkbox } from "components/Form/SpecialButtons";
moment.locale("fr");

const styles = {
	patientLabelGrid: {
		textAlign: "right",
		paddingRight: "10px",
	},
	patientValueGrid: {
		textAlign: "left",
		fontWeight: "bold",
	},
};

const IdentitoVigilanceModal = ({ open, close, submit, patient, tvSecActivated, secretaries }) => {
	const [counter, setCounter] = useState(3);
	const isMobile = useIsMobileView();

	useEffect(() => {
		if (open) {
			setCounter(3);
			const timer = setInterval(() => setCounter((counter) => counter - 1), 2000);
			setTimeout(() => {
				clearInterval(timer);
			}, 7000);
		}
	}, [open]);

	return (
		<Formik
			initialValues={{
				tvSec: false,
				deposit: false,
			}}
		>
			{({ values, setFieldValue }) => (
				<Form>
					<Modal size="small" open={open} closeOnEscape closeOnDimmerClick onClose={close}>
						<Modal.Header>Identité du patient sélectionné</Modal.Header>
						<Modal.Content>
							<Message style={{ fontSize: "0.9em" }}>
								<Message.Header>Identito-vigilance</Message.Header>
								<p>
									L'identito-vigilance est l'ensemble des mesures mises en œuvre pour fiabiliser l'identification du patient afin de sécuriser ses
									données de santé, à toutes les étapes de sa prise en charge.
								</p>
							</Message>
							<Grid key={`grid-${patient.id}`} style={{ paddingTop: "25px" }}>
								{isMobile ? (
									<Table celled striped style={{ fontSize: "85%" }}>
										<Table.Header>
											<Table.Row>
												<Table.HeaderCell colSpan="3" style={{ textTransform: "uppercase", fontSize: "15px" }}>
													Questions à poser au patient
												</Table.HeaderCell>
											</Table.Row>
										</Table.Header>
										<Table.Body style={{ textAlign: "center" }}>
											<Table.Row>
												<Table.Cell>Confirmez-moi votre NOM DE NAISSANCE ?</Table.Cell>
												<Table.Cell style={{ fontWeight: "bold", fontSize: "13px" }}>{patient.birth_name || patient.last_name || "-"}</Table.Cell>
											</Table.Row>
											<Table.Row>
												<Table.Cell>Confirmez-moi votre PRENOM ?</Table.Cell>
												<Table.Cell style={{ fontWeight: "bold", fontSize: "13px" }}>{patient.first_name || "-"}</Table.Cell>
											</Table.Row>
											<Table.Row>
												<Table.Cell>Confirmez-moi votre DATE DE NAISSANCE ?</Table.Cell>
												<Table.Cell style={{ fontWeight: "bold", fontSize: "13px" }}>
													{patient.birth_date ? moment(patient.birth_date).format("DD MMM YYYY") : "non communiquée"}
												</Table.Cell>
											</Table.Row>
										</Table.Body>
										<Table.Header>
											<Table.Row>
												<Table.HeaderCell colSpan="3" style={{ textTransform: "uppercase", fontSize: "15px" }}>
													Autres informations du patient
												</Table.HeaderCell>
											</Table.Row>
										</Table.Header>
										<Table.Body style={{ textAlign: "center" }}>
											<Table.Row>
												<Table.Cell>Genre :</Table.Cell>
												<Table.Cell style={{ fontWeight: "bold", fontSize: "13px" }}>
													{(patient.gender === "male" || patient.gender === "m" || patient.gender === "M") && "Homme"}{" "}
													{patient.gender !== "male" && patient.gender !== "m" && patient.gender !== "M" && "Femme"}
												</Table.Cell>
											</Table.Row>
											<Table.Row>
												<Table.Cell>Téléphone :</Table.Cell>
												<Table.Cell style={{ fontWeight: "bold", fontSize: "13px" }}>
													{patient.mobile_phone || patient.mobilephone || "non communiqué"}
												</Table.Cell>
											</Table.Row>
											<Table.Row>
												<Table.Cell>Email :</Table.Cell>
												<Table.Cell style={{ fontWeight: "bold", fontSize: "13px" }}>{patient.email || "non communiqué"}</Table.Cell>
											</Table.Row>
											{patient.identity_number && (
												<Table.Row>
													<Table.Cell>N° pièce d'identité :</Table.Cell>
													<Table.Cell style={{ fontWeight: "bold", fontSize: "13px" }}>{patient.identity_number || "non communiqué"}</Table.Cell>
												</Table.Row>
											)}
											{patient.marital_name && (
												<Table.Row>
													<Table.Cell>Nom marital:</Table.Cell>
													<Table.Cell style={{ fontWeight: "bold", fontSize: "13px" }}>{patient.marital_name || "-"}</Table.Cell>
												</Table.Row>
											)}
											<Table.Row>
												<Table.Cell collapsing>Matricule :</Table.Cell>
												<Table.Cell style={{ fontWeight: "bold", fontSize: "13px" }}>
													{patient.matricule || patient.cns || "non communiqué"}
												</Table.Cell>
											</Table.Row>
											<Table.Row>
												<Table.Cell>Adresse :</Table.Cell>
												<Table.Cell style={{ fontWeight: "bold", fontSize: "13px" }}>
													{getPatientHomeAddress(convertMyLabToPatient(patient)) || "non communiqué"}
												</Table.Cell>
											</Table.Row>
											{tvSecActivated && (
												<Table.Row>
													<Table.Cell>
														<div style={{ display: "flex", width: "100%", justifyContent: "flex-end" }}>
															<Field
																component={Checkbox}
																name="tvSec"
																id="tvSec"
																customlabel="Faire saisir le dossier par le télésecrétariat"
																style={{ marginTop: 0 }}
															/>
														</div>
													</Table.Cell>
												</Table.Row>
											)}

											<Table.Row>
												<Table.Cell>
													<div style={{ display: "flex", width: "100%", justifyContent: "flex-end" }}>
														<Field component={Checkbox} name="deposit" id="deposit" customlabel="Dépot d'un prélèvement" style={{ marginTop: 0 }} />
													</div>
												</Table.Cell>
											</Table.Row>
										</Table.Body>
									</Table>
								) : (
									<>
										<Grid.Row columns={1} style={{ textAlign: "center", textTransform: "uppercase", paddingBottom: 0 }}>
											<Grid.Column>Questions à poser au patient</Grid.Column>
										</Grid.Row>
										<Grid.Row columns={2} style={{ fontSize: isMobile ? "1em" : "1.1em" }}>
											<Grid.Column style={styles.patientLabelGrid}> Confirmez-moi votre NOM DE NAISSANCE ? </Grid.Column>
											<Grid.Column style={styles.patientValueGrid}> {patient.birth_name || patient.last_name || "-"}</Grid.Column>
											<Grid.Column style={styles.patientLabelGrid}> Confirmez-moi votre PRENOM ? </Grid.Column>
											<Grid.Column style={styles.patientValueGrid}>{patient.first_name || "-"}</Grid.Column>
											<Grid.Column style={styles.patientLabelGrid}> Confirmez-moi votre DATE DE NAISSANCE ? </Grid.Column>
											<Grid.Column style={styles.patientValueGrid}>
												{patient.birth_date ? moment(patient.birth_date).format("DD MMM YYYY") : "non communiquée"}
											</Grid.Column>
										</Grid.Row>
										<Grid.Row columns={1} style={{ textAlign: "center", textTransform: "uppercase", paddingBottom: 0 }}>
											<Grid.Column>Autres informations du patient</Grid.Column>
										</Grid.Row>
										<Grid.Row columns={2}>
											<Grid.Column style={styles.patientLabelGrid}> Genre: </Grid.Column>
											<Grid.Column style={styles.patientValueGrid}>
												{(patient.gender === "male" || patient.gender === "m" || patient.gender === "M") && "Homme"}{" "}
												{patient.gender !== "male" && patient.gender !== "m" && patient.gender !== "M" && "Femme"}
											</Grid.Column>
											<Grid.Column style={styles.patientLabelGrid}> Téléphone: </Grid.Column>
											<Grid.Column style={styles.patientValueGrid}>{patient.mobile_phone || patient.mobilephone || "non communiqué"} </Grid.Column>
											<Grid.Column style={styles.patientLabelGrid}> Email: </Grid.Column>
											<Grid.Column style={styles.patientValueGrid}>{patient.email || "non communiqué"}</Grid.Column>
											{patient.identity_number && (
												<>
													<Grid.Column style={styles.patientLabelGrid}> N° pièce d'identité: </Grid.Column>
													<Grid.Column style={styles.patientValueGrid}>{patient.identity_number || "non communiqué"}</Grid.Column>
												</>
											)}
											{patient.marital_name && (
												<>
													<Grid.Column style={styles.patientLabelGrid}> Nom marital: </Grid.Column>
													<Grid.Column style={styles.patientValueGrid}> {patient.marital_name || "-"}</Grid.Column>
												</>
											)}
											<Grid.Column style={styles.patientLabelGrid}> Matricule: </Grid.Column>
											<Grid.Column style={styles.patientValueGrid}>{patient.matricule || patient.cns || "non communiqué"}</Grid.Column>
											<Grid.Column style={styles.patientLabelGrid}> Adresse: </Grid.Column>
											<Grid.Column style={styles.patientValueGrid}>
												{getPatientHomeAddress(convertMyLabToPatient(patient)) || "non communiqué"}
											</Grid.Column>
										</Grid.Row>
										{tvSecActivated && (
											<Grid.Row>
												<Grid.Column style={styles.patientLabelGrid}>
													<div style={{ display: "flex", width: "100%", justifyContent: "flex-end" }}>
														<Field
															component={Checkbox}
															name="tvSec"
															id="tvSec"
															customlabel={`Faire saisir le dossier par le télésecrétariat - ${
																secretaries.length > 0 ? secretaries.length : "Pas de "
															} secrétaire${secretaries.length > 1 ? "s" : ""} active${secretaries.length > 1 ? "s" : ""}`}
															style={{ marginTop: 0 }}
														/>
													</div>
												</Grid.Column>
											</Grid.Row>
										)}
										<Grid.Row>
											<Grid.Column style={styles.patientLabelGrid}>
												<div style={{ display: "flex", width: "100%", justifyContent: "flex-end" }}>
													<Field component={Checkbox} name="deposit" id="deposit" customlabel="Dépot d'un prélèvement" style={{ marginTop: 0 }} />
												</div>
											</Grid.Column>
										</Grid.Row>
									</>
								)}
							</Grid>
						</Modal.Content>
						<Modal.Actions>
							<Button
								onClick={(e) => {
									if (e !== undefined) e.preventDefault();
									close();
								}}
							>
								Annuler
							</Button>
							<Button
								primary
								onClick={(e) => {
									if (e !== undefined) e.preventDefault();
									submit(values.tvSec, values.deposit);
									setFieldValue("tvSec", false);
									setFieldValue("deposit", false);
								}}
							>
								Je confirme
							</Button>
						</Modal.Actions>
					</Modal>
				</Form>
			)}
		</Formik>
	);
};

export default IdentitoVigilanceModal;
